import './StatsCard.css';

export const StatsCard = ({ title, value, unit, subtext, change, changeType, sentiment, icon }) => {
  // changeType drives the arrow (↑/↓); optional sentiment ('good'|'bad') drives
  // the color — for emissions an increase is bad, so ↑ can render red.
  const getChangeClass = () => {
    if (!change) return '';
    const positive = sentiment ? sentiment === 'good' : changeType === 'increase';
    return positive ? 'stats-change-positive' : 'stats-change-negative';
  };

  return (
    <div className="stats-card">
      <div className="stats-card-header">
        {icon && <div className="stats-card-icon">{icon}</div>}
        <div className="stats-card-header-right">
          <h3 className="stats-card-title">{title}</h3>
          {change && (
            <div className={`stats-card-change ${getChangeClass()}`}>
              <span className="change-icon">{changeType === 'increase' ? '↑' : '↓'}</span>
              {change}
            </div>
          )}
        </div>
      </div>
      <div className="stats-card-body">
        <div className="stats-card-value-container">
          <span className="stats-card-value">{value}</span>
          {unit && <span className="stats-card-unit">{unit}</span>}
        </div>
        {subtext && <div className="stats-card-subtext">{subtext}</div>}
      </div>
    </div>
  );
};
